"use client";
import { forwardRef } from "react";
import { cn } from "@/lib/utils/utils";

interface TechNodeProps {
  name: string; // "" when this is a structural filler dot
  label: boolean; // true → labelled chip; false → glass dot
  important: boolean; // core tech → larger, heavier chip
  accent: string;
}

const NODE_BG = "#212129";

const TechNode = forwardRef<HTMLDivElement, TechNodeProps>(
  ({ name, label, important, accent }, ref) => {
    return (
      <div
        ref={ref}
        style={{ opacity: 0 }}
        className="pointer-events-none absolute left-0 top-0 will-change-transform"
      >
        <div className="relative -translate-x-1/2 -translate-y-1/2">
          {label ? (
            <div
              className={cn(
                "select-none whitespace-nowrap rounded-full border tracking-wide",
                important
                  ? "px-3.5 py-1.5 text-sm font-bold"
                  : "px-3 py-1 text-xs font-semibold",
              )}
              style={{
                color: accent,
                backgroundColor: NODE_BG,
                borderColor: `${accent}4d`,
                boxShadow: important
                  ? `0 8px 20px -10px ${accent}, 0 0 0 3px ${accent}1f`
                  : `0 6px 16px -12px ${accent}`,
              }}
            >
              <span
                className="mr-1.5 inline-block h-1.5 w-1.5 rounded-full align-middle"
                style={{ backgroundColor: accent }}
              />
              {name}
            </div>
          ) : (
            <span
              className="block h-2 w-2 rounded-full"
              style={{
                background: `radial-gradient(circle at 35% 30%, #fff, ${NODE_BG})`,
                boxShadow: `0 0 0 1px ${accent}33`,
              }}
            />
          )}
        </div>
      </div>
    );
  },
);

TechNode.displayName = "TechNode";
export default TechNode;
